import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import {
  Button,
  ButtonGroup,
  Form,
  Pagination,
  Table,
  ToggleButton,
} from "react-bootstrap";
import { helpHttp } from "../../helpers/helpHttp";
import Loader from "../../common/loader/Loader";

const OPTION_SEARCH = {
  UseName: "1",
  LastConnection: "2",
};

const OPTION_BUTTONS = [
  { name: "UseName", value: OPTION_SEARCH.UseName },
  { name: "LastConnection", value: OPTION_SEARCH.LastConnection },
];

export default function Users() {
  const [users, setUsers] = useState(null);
  const [activePage, setActivePage] = useState(1);
  const [maxPages, setMaxPages] = useState(1);
  const [addSearch, setAddSearch] = useState("");
  const [search, setSearch] = useState("");
  const [loaderSearch, setLoaderSearch] = useState(true);
  const [radioValue, setRadioValue] = useState(OPTION_SEARCH.UseName);

  let active = activePage;
  let items = [];
  for (let number = 1; number <= maxPages; number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === active}
        onClick={() => setActivePage(number)}
      >
        {number}
      </Pagination.Item>
    );
  }

  useEffect(() => {
    setLoaderSearch(true);
    const URL_USERS = `${process.env.REACT_APP_API_DOMAIN}${
      process.env.REACT_APP_GET_USER
    }?page=${activePage ? activePage : 1}${addSearch}`;
    let options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    fetch(URL_USERS, options)
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error(
            "Error en la solicitud. Código de estado: " + res.status
          );
        }
      })
      .then((data) => {
        setUsers(data.content);
        setActivePage(data.pageNumber);
        setMaxPages(data.totalPages !== 0 ? data.totalPages : 1);
        setLoaderSearch(false);
      })
      .catch((err) => {
        setLoaderSearch(false);
        setUsers([]);
      });
  }, [activePage, addSearch]);

  const sendSearch = (e) => {
    e.preventDefault();
    setActivePage(1);

    let option;
    if (radioValue === OPTION_SEARCH.UseName) option = "userName";
    if (radioValue === OPTION_SEARCH.LastConnection) option = "hours";

    if (search !== "") {
      setAddSearch(`&${option}=${search}`);
    } else {
      setAddSearch("");
    }
  };

  function formatDateTime(dateTimeString) {
    const date = new Date(dateTimeString);

    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();

    return `${hours}:${minutes} ${day}-${month}-${year}`;
  }

  return (
    <>
      <div className="d-flex justify-content-end container-search  mb-3 mt-4">
        <ButtonGroup>
          {OPTION_BUTTONS.map((radio, idx) => (
            <ToggleButton
              key={idx}
              id={`radio-${idx}`}
              type="radio"
              variant="secondary"
              name="radio"
              value={radio.value}
              checked={radioValue === radio.value}
              onChange={(e) => setRadioValue(e.currentTarget.value)}
              className="button-group"
            >
              {radio.name}
            </ToggleButton>
          ))}
        </ButtonGroup>
        <Form className="d-flex ms-4" onSubmit={sendSearch}>
          <Form.Control
            type="search"
            placeholder="Search"
            className="me-2"
            aria-label="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <Button
            variant="outline-success"
            type="submite"
            className="button-group mt-2"
          >
            Search
          </Button>
        </Form>
      </div>
      <Table striped bordered hover className="hoverable">
        <thead>
          <tr>
            <th>UserName</th>
            <th>Ultima conexion</th>
          </tr>
        </thead>
        {users && (
          <tbody>
            {users?.map((user) => (
              <tr key={user.userId}>
                <td>{user.userId}</td>
                <td>{formatDateTime(user.date)}</td>
              </tr>
            ))}
          </tbody>
        )}
        {users?.length < 1 ? (
          <tbody className="text-center">
            <tr>
              <td colSpan="2">No hay datos</td>
            </tr>
          </tbody>
        ) : null}
      </Table>
      {loaderSearch && <Loader />}
      <div className="d-flex justify-content-center">
        <Pagination>{items}</Pagination>
      </div>
    </>
  );
}
